import { render, staticRenderFns } from "./AmendmentAnalysis.vue?vue&type=template&id=4372baf8"
import script from "./AmendmentAnalysis.vue?vue&type=script&lang=js"
export * from "./AmendmentAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports